<script setup lang="ts">
import { useAudioStore } from '../stores/audioStore';

const audioStore = useAudioStore();

function handlePanicStop() {
  audioStore.panicStop();
}
</script>

<template>
  <div class="fixed bottom-28 left-0 right-0 px-4 flex justify-center pointer-events-none z-40">
    <button
      @click="handlePanicStop"
      class="pointer-events-auto bg-red-600 hover:bg-red-700 text-white px-10 py-4 rounded-full text-sm font-black uppercase tracking-widest shadow-[0_0_30px_rgba(220,38,38,0.6)] active:scale-95 transition-all flex items-center gap-3"
    >
      <span class="material-symbols-outlined text-2xl">stop_circle</span>
      PANIC STOP ALL
    </button>
  </div>
</template>
